var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoItem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 54.6879C44.3712 54.6879 54.4 44.6591 54.4 32.2879C54.4 19.9168 44.3712 9.88794 32 9.88794C19.6288 9.88794 9.59998 19.9168 9.59998 32.2879C9.59998 44.6591 19.6288 54.6879 32 54.6879Z",
    fill: "#E0E9EA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_77_888)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.4,
    y: 24,
    width: 27.2,
    height: 34.4,
    rx: 12,
    fill: "#1B565E",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 49.6C17.6 53.3712 17.6 55.2568 18.7715 56.4284C19.9431 57.6 21.8287 57.6 25.6 57.6L38.4 57.6C42.1712 57.6 44.0568 57.6 45.2284 56.4284C46.4 55.2568 46.4 53.3712 46.4 49.6L46.4 27.2L36.8 16.8L25.6 16.8C21.8287 16.8 19.9431 16.8 18.7716 17.9716C17.6 19.1431 17.6 21.0287 17.6 24.8L17.6 49.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7999 27.2L46.3999 27.2L36.7999 16.8L36.7999 25.2C36.7999 26.3045 37.6954 27.2 38.7999 27.2Z",
    fill: "#B3D4D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3353 9.92836C47.6933 10.1367 47.8147 10.5958 47.6064 10.9538L44.7591 15.8478C44.5508 16.2058 44.0917 16.3272 43.7336 16.1189C43.3756 15.9106 43.2542 15.4515 43.4625 15.0935L46.3098 10.1995C46.5181 9.84145 46.9772 9.72007 47.3353 9.92836ZM39.4089 9.83207C39.8227 9.81377 40.173 10.1344 40.1913 10.5482L40.3046 13.1117C40.323 13.5255 40.0023 13.8758 39.5885 13.8941C39.1747 13.9124 38.8244 13.5918 38.8061 13.178L38.6927 10.6145C38.6744 10.2007 38.9951 9.85037 39.4089 9.83207ZM52.1471 16.4876C52.5017 16.2736 52.6157 15.8126 52.4017 15.458C52.1877 15.1033 51.7267 14.9893 51.3721 15.2033L46.9547 17.8691C46.6001 18.0831 46.4861 18.5441 46.7001 18.8987C46.9141 19.2533 47.3751 19.3673 47.7297 19.1533L52.1471 16.4876Z",
    fill: "#75A3A7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.99998,
    cy: 40,
    rx: 2.4,
    ry: 2.4,
    fill: "#E0E9EA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.2,
    cy: 20.8001,
    rx: 1.6,
    ry: 1.6,
    fill: "#E0E9EA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.40007,
    cy: 22.8,
    rx: 1.2,
    ry: 1.2,
    fill: "#E0E9EA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.8,
    cy: 15.2,
    rx: 0.799999,
    ry: 0.8,
    fill: "#E0E9EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 24,
    width: 8,
    height: 1.6,
    rx: 0.8,
    fill: "#E0E9EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 28.8,
    width: 12,
    height: 1.6,
    rx: 0.8,
    fill: "#E0E9EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 33.6,
    width: 20.8,
    height: 1.6,
    rx: 0.8,
    fill: "#E0E9EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 38.4,
    width: 20.8,
    height: 1.6,
    rx: 0.8,
    fill: "#E0E9EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 43.2001,
    width: 20.8,
    height: 1.6,
    rx: 0.799999,
    fill: "#E0E9EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_77_888",
    x: 8.40002,
    y: 14,
    width: 47.2,
    height: 54.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_77_888"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItem);
export default __webpack_public_path__ + "static/media/no-item.7c80a7c17f6884f2d0ace57ac39a3aab.svg";
export { ForwardRef as ReactComponent };